<div class="content">
  <div class="form-login">
    <div class="main-title"><span>SatPhoneRecharge</span></div>
    <hr class="dashed-line">
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
      <div class="input-control">
        <label for="email">email</label>
        <input formControlName="email" id="email" maxlength="150" type="text"/>
        <div *ngIf="!form.get('email')?.valid && form.get('email')?.touched"
             class="help-block">Please enter valid email
        </div>
      </div>

      <div class="input-control">
        <label for="pwd">hasło</label>
        <input formControlName="password" id="pwd" maxlength="150" type="password"/>
        <span *ngIf="!form.get('password')?.valid && form.get('password')?.touched"
              class="help-block">Please enter password
      </span>
      </div>

      <div class="buttons" style="justify-content: space-between">
        <button onClick="clearForm()" type="reset">Wyczyść</button>
        <button [disabled]="!isFormValid" type="submit">Zaloguj
        </button>
      </div>
    </form>
    <footer class="content-footer">
      <img alt="logo" src="assets/parp-logo.jpg">
    </footer>
  </div>
</div>
